import { NETWORK_DASHBOARD_STORE_AGE_FILTERS } from '@gozoki/api-types'
import { z } from 'zod'

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)

/**
 * Filtres de l'écran Inventaires, portés par l'URL (kanban #822). Sans `date` : aujourd'hui
 * (journée Europe/Paris, résolue côté client ET côté serveur) ; sans boutique : toutes les
 * boutiques ouvertes. L'ancienneté réutilise l'accordéon de `DashboardFilters` comme le RH.
 */
export const inventoriesSearchSchema = z.object({
  date: isoDate.optional(),
  storeIds: z.array(z.number()).optional(),
  storeAgeFilter: z.enum(NETWORK_DASHBOARD_STORE_AGE_FILTERS).optional().default('default'),
  ageStoreIds: z.array(z.number()).optional(),
})

export type InventoriesSearch = z.infer<typeof inventoriesSearchSchema>
